import { Box, Button, List, PopoverMenu, Tag, Text } from '@factorialco/deprecated-design-system'
import { SalesDocumentTemplateFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  salesDocumentTemplate: SalesDocumentTemplateFragment
  onEdit: () => void
  onDelete: () => void
}

export const ListItemSalesDocumentTemplate = ({
  salesDocumentTemplate,
  onEdit,
  onDelete,
}: Props) => {
  return (
    <List.Item>
      <Box flexDirection="column" gap="s4">
        <Text.Normal weight="semibold">{salesDocumentTemplate.name}</Text.Normal>
        <Text.Normal size="100">{salesDocumentTemplate.legalEntity.legalName}</Text.Normal>
        <Box flexDirection="row" gap="s8">
          {salesDocumentTemplate.default && (
            <Tag type="champagne">{i18n.t('finance.sales_document_templates.list.default')}</Tag>
          )}
        </Box>
      </Box>
      <Box flexDirection="column" justifyContent="spaceBetween" height="full">
        <Box flexDirection="column" justifyContent="center" height="full" alignItems="flexEnd">
          <PopoverMenu type="list">
            <PopoverMenu.Trigger asChild>
              <Button iconName="ellipsis" type="secondary" />
            </PopoverMenu.Trigger>
            <PopoverMenu.Content side="bottom" align="end">
              <PopoverMenu.TouchableOption
                title={i18n.t('common.edit')}
                icon="pencil"
                onClick={onEdit}
              />
              <PopoverMenu.TouchableOption
                title={i18n.t('common.delete')}
                icon="delete"
                danger
                onClick={onDelete}
              />
            </PopoverMenu.Content>
          </PopoverMenu>
        </Box>
      </Box>
    </List.Item>
  )
}
